import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import styles from "./styles/style.module.scss";

const SaveChangesButton = ({ className = "" }) => {
    return (
        <Row className={className}>
            <Col lg={4} xs={12}>
                <div className={styles["save-changes-button"]}>
                    <Button
                        variant="transparent"
                        className="save-btn"
                        type="submit"
                    >
                        <FormattedMessage id={"saveChanges"} />
                    </Button>
                </div>
            </Col>
        </Row>
    );
};

export default SaveChangesButton;
